export default __webpack_public_path__ + "images/d75606bdef25672b8030c21c504bb2d8-adoption-cat-666.gif";